"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketAnalyticsConfigurationInput_1 = require("./PutBucketAnalyticsConfigurationInput");
var PutBucketAnalyticsConfigurationOutput_1 = require("./PutBucketAnalyticsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketAnalyticsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketAnalyticsConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?analytics"
    },
    input: {
        shape: PutBucketAnalyticsConfigurationInput_1.PutBucketAnalyticsConfigurationInput
    },
    output: {
        shape: PutBucketAnalyticsConfigurationOutput_1.PutBucketAnalyticsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketAnalyticsConfiguration.js.map